// extracted by mini-css-extract-plugin
export default {"link":"aQ-z","disabled":"bQ-z"};